// extracted by mini-css-extract-plugin
module.exports = {"value":"value--Z8KDQ"};